import { px2rem, MEDIA_QUERY, useScrollStyle } from '@moim/common';
import styled from 'styled-components';

var BodyWrapper = styled.div.withConfig({
  displayName: "BodyWrapper",
  componentId: "sc-67lipn-0"
})(["width:", ";align-items:center;align-self:center;flex:1;min-height:", ";@media ", "{width:100%;min-height:inherit;}"], px2rem(370), px2rem(700), MEDIA_QUERY.ONLY_MOBILE);
var ScrollContainer = styled.div.withConfig({
  displayName: "ScrollContainer",
  componentId: "sc-67lipn-1"
})(["width:100%;height:100%;", ""], useScrollStyle);
var SectionTitle = styled.div.withConfig({
  displayName: "SectionTitle",
  componentId: "sc-67lipn-2"
})(["padding:", " ", ";color:", ";"], px2rem(8), px2rem(16), function (props) {
  return props.theme.colorV2.colorSet.grey800;
});
var SectionBody = styled.div.withConfig({
  displayName: "SectionBody",
  componentId: "sc-67lipn-3"
})(["padding:0 ", ";display:flex;flex-direction:column;row-gap:", ";"], px2rem(18), px2rem(8));
var SectionContainer = styled.div.withConfig({
  displayName: "SectionContainer",
  componentId: "sc-67lipn-4"
})(["margin-bottom:", ";"], px2rem(24));
var EmptyEventWrapper = styled.div.withConfig({
  displayName: "EmptyEventWrapper",
  componentId: "sc-67lipn-5"
})(["> div{height:50dvh;}"]);

export { BodyWrapper, EmptyEventWrapper, ScrollContainer, SectionBody, SectionContainer, SectionTitle };
